// extracted by mini-css-extract-plugin
export default {"ownProposalCell":"ownProposalCell---Hzb4V"};